// extracted by mini-css-extract-plugin
export default {"teacherGrid":"teacherinfo_teacherGrid__pL5Fx"};